"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UPSELL_TYPE = void 0;
var _getRewardsPortableText = _interopRequireDefault(require("../../shared/get-rewards-portable-text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var UPSELL_TYPE = exports.UPSELL_TYPE = {
  EXTRAS: 'extras cover',
  HOSPITAL: 'hospital cover',
  NONE: null
};
var getPresaleSentence = function getPresaleSentence(_ref) {
  var offer = _ref.offer,
    rewards = _ref.rewards,
    upsell = _ref.upsell,
    _ref$isRestricted = _ref.isRestricted,
    isRestricted = _ref$isRestricted === void 0 ? false : _ref$isRestricted;
  return {
    value: [{
      value: upsell ? "Add ".concat(isRestricted ? 'eligible ' : '').concat(upsell) : 'Join and maintain this cover'
    }, {
      value: ' and you can get '
    }].concat(_toConsumableArray((0, _getRewardsPortableText["default"])({
      offer: offer,
      rewards: rewards
    })))
  };
};
var _default = exports["default"] = getPresaleSentence;